import { render, staticRenderFns } from "./AutoTag.vue?vue&type=template&id=36618fe6"
import script from "./AutoTag.vue?vue&type=script&lang=js"
export * from "./AutoTag.vue?vue&type=script&lang=js"
import style0 from "./AutoTag.vue?vue&type=style&index=0&id=36618fe6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports